import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cdb909e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Protect your Digital Identity"),
  /*#__PURE__*/_createElementVNode("p", null, " Digital identity is a new reality, it appears complex or wird because we have no practice on that subject. The goal of this application is to provide a few solutions to protect your identiy without the needs of a trusted thirdparties. ")
], -1))
const _hoisted_3 = { class: "media-display" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "The BIP39 Mnemonic standard ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Mnemonic phrase constitutes all the necessary information required to recover your wallets and «digital states» if your device is stolen or gets damaged. In such instances, you can recover your wallets by keying in the mnemonic phrase words on all wallets software that use standardised BIP39. ", -1))
const _hoisted_6 = { class: "languages hide" }
const _hoisted_7 = { class: "mnemonic" }
const _hoisted_8 = { class: "media-display actions" }
const _hoisted_9 = ["selected", "value"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Move the cursor! ")
const _hoisted_12 = { class: "form-group hide" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "seed",
  class: "col-sm-2 control-label"
}, "BIP39 Seed", -1))
const _hoisted_14 = { class: "col-sm-10" }
const _hoisted_15 = { class: "sharing" }
const _hoisted_16 = { class: "header" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Use Horcruxes/SSS to recover your identity", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("To increase the security of your identity, We break the Menominc phrase in 3 separate pieces (called Horcruxes). Your need at ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "least two pieces", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" to reconstitute your identity. You decide where you want to store each Horcrux. We recomend you keep them in separate places/locations. We provide a few alternatives (do not keep all of them on trusted thirdparties): ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Store them on printed paper and keep them in separate places/locations.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Use our Vault SmartContract a digital and secure space to store ONE Horcrux.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Or store ONE Horcrux on cloud provider", -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "action" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "store" }, "dropbox/microsoft/google", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr = _resolveComponent("qr")!
  const _component_entropy_from_mouse = _resolveComponent("entropy-from-mouse")!
  const _component_horcrux_print = _resolveComponent("horcrux-print")!
  const _component_drawer = _resolveComponent("drawer")!
  const _component_horcrux_vault = _resolveComponent("horcrux-vault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("fieldset", null, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onI18n('en'))),
            href: "#english"
          }, "English"),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onI18n('jp'))),
            href: "#japanese",
            title: "Japanese"
          }, "日本語"),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onI18n('es'))),
            href: "#spanish",
            title: "Spanish"
          }, "Español"),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onI18n('fr'))),
            href: "#chinese_simplified",
            title: "Chinese (Simplified)"
          }, "中文(简体)"),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onI18n('fr'))),
            href: "#chinese_traditional",
            title: "Chinese (Traditional)"
          }, "中文(繁體)"),
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onI18n('fr'))),
            href: "#french",
            title: "French"
          }, "Français"),
          _createElementVNode("a", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onI18n('it'))),
            href: "#italian",
            title: "Italian"
          }, "Italiano"),
          _createElementVNode("a", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onI18n('ko'))),
            href: "#korean",
            title: "Korean"
          }, "한국어"),
          _createElementVNode("a", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onI18n('cz'))),
            href: "#czech",
            title: "Czech"
          }, "Čeština"),
          _createElementVNode("a", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onI18n('po'))),
            href: "#portuguese",
            title: "Portuguese"
          }, "Português")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("textarea", {
        ref: "textarea",
        onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mnemonic) = $event)),
        class: "phrase private-data",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false"
      }, "              \n        ", 544), [
        [_vModelText, _ctx.mnemonic]
      ]),
      (_ctx.seed)
        ? (_openBlock(), _createBlock(_component_qr, {
            key: 0,
            class: "qrcode",
            message: _ctx.mnemonic
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("select", {
          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChange($event)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mnemonicLength, (option, value) => {
            return (_openBlock(), _createElementBlock("option", {
              selected: option.selected,
              value: value,
              key: value
            }, _toDisplayString(option.label), 9, _hoisted_9))
          }), 128))
        ], 32),
        _createElementVNode("button", {
          class: "button button-outline",
          disabled: _ctx.isInvalidMnemonic,
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onRetrieve && _ctx.onRetrieve(...args)))
        }, "HORCRUXES", 8, _hoisted_10),
        _createElementVNode("button", {
          class: "button button-outline",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onStart && _ctx.onStart(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["initial", { hide : _ctx.entropyStart }])
          }, "Generate", 2),
          _createVNode(_component_entropy_from_mouse, {
            ref: "entropyGen",
            disabled: !_ctx.isInvalidMnemonic,
            class: _normalizeClass({ hide : !_ctx.entropyStart }),
            bitCount: 192,
            onStart: _ctx.onEntropyStart,
            onComplete: _ctx.onEntropyCollected
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["disabled", "class", "onStart", "onComplete"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.seed) = $event)),
          class: "seed private-data",
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          spellcheck: "false"
        }, null, 512), [
          [_vModelText, _ctx.seed]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", null, [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("ul", {
            class: _normalizeClass({hide1:(!_ctx.shares.length)})
          }, _hoisted_24, 2)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shares, (share, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "secret",
          key: index
        }, [
          _createTextVNode(_toDisplayString(share) + " ", 1),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("a", {
              class: "store",
              onClick: ($event: any) => (_ctx.onHorcrux(share,'print'))
            }, "print", 8, _hoisted_26),
            _createElementVNode("a", {
              class: "store",
              onClick: ($event: any) => (_ctx.onHorcrux(share,'vault'))
            }, "vault", 8, _hoisted_27),
            _hoisted_28
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_drawer, {
      open: _ctx.drawer.print,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onHorcrux(null,'print')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_horcrux_print, { value: _ctx.currentHorcrux }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_drawer, {
      open: _ctx.drawer.vault,
      displayClose: true,
      onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onHorcrux(null,'vault')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_horcrux_vault, { value: _ctx.currentHorcrux }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}